const PRE = 'el';
export default {
    button: PRE + 'Button',
    icon: 'i',
    slider: PRE + 'Slider',
    rate: PRE + 'Rate',
    upload: 'fcUpload',
    cascader: PRE + 'Cascader',
    popover: PRE + 'Popover',
    tooltip: PRE + 'Tooltip',
    colorPicker: PRE + 'ColorPicker',
    timePicker: PRE + 'TimePicker',
    timeSelect: PRE + 'TimeSelect',
    datePicker: PRE + 'DatePicker',
    'switch': PRE + 'Switch',
    select: 'fcSelect',
    checkbox: 'fcCheckbox',
    radio: 'fcRadio',
    inputNumber: PRE + 'InputNumber',
    number: PRE + 'InputNumber',
    input: PRE + 'Input',
    formItem: PRE + 'FormItem',
    form: PRE + 'Form',
    frame: 'fcFrame',
    col: PRE + 'Col',
    row: PRE + 'Row',
    tree: 'fcTree',
    autoComplete: PRE + 'Autocomplete',
    auto: PRE + 'Autocomplete',
    group: 'fcGroup',
    object: 'fcSubForm',
    subForm: 'fcSubForm',
}
